import React from 'react';
const UploadFileIconSVG = ({ className, parentClassName }) => (
  <svg
    width="26"
    height="31"
    viewBox="0 0 26 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={parentClassName}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26 9.04169C26 8.69935 25.8634 8.37015 25.6191 8.12842L17.8191 0.37842C17.5759 0.135728 17.2446 0 16.9 0H1.3C0.582465 0 0 0.578725 0 1.29167V29.7083C0 30.4213 0.582458 31 1.3 31H24.7C25.4175 31 26 30.4213 26 29.7083L26 9.04169ZM6.50002 24.5417H19.5C20.2175 24.5417 20.8 23.963 20.8 23.25C20.8 22.5371 20.2175 21.9584 19.5 21.9584H6.50002C5.78249 21.9584 5.20002 22.5371 5.20002 23.25C5.20002 23.963 5.78248 24.5417 6.50002 24.5417ZM6.50002 19.375H19.5C20.2175 19.375 20.8 18.7963 20.8 18.0834C20.8 17.3704 20.2175 16.7917 19.5 16.7917H6.50002C5.78249 16.7917 5.20002 17.3704 5.20002 18.0834C5.20002 18.7963 5.78248 19.375 6.50002 19.375ZM6.50002 14.2084H14.3C15.0175 14.2084 15.6 13.6296 15.6 12.9167C15.6 12.2038 15.0176 11.625 14.3 11.625H6.50002C5.78249 11.625 5.20002 12.2038 5.20002 12.9167C5.20002 13.6296 5.78248 14.2084 6.50002 14.2084Z"
      className={`${className} notification-SVG`}
    />
  </svg>
);

const DownloadAllFileIconSVG = ({ className, parentClassName }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={parentClassName}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.26995 6.19738H11.5557L7.55566 10.315L3.55566 6.19738H5.84138V2.66797H9.26995V6.19738ZM3.55566 12.6674V11.4909H11.5557V12.6674H3.55566Z"
      className={`${className} sidenav-SVG`}
    />
  </svg>
);

const IconSVG = ({ className, parentClassName }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={parentClassName}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.26995 6.19738H11.5557L7.55566 10.315L3.55566 6.19738H5.84138V2.66797H9.26995V6.19738ZM3.55566 12.6674V11.4909H11.5557V12.6674H3.55566Z"
      className={`${className} downloadFile-SVG`}
    />
  </svg>
);

const SendDocumentIconSVG = ({ className, parentClassName }) => (
  <svg
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={parentClassName}
  >
    <path
      d="M7.25431 7.96486L1.53887 8.53564L0.0345806 13.499C-0.0242917 13.6915 -0.00751413 13.9002 0.0812512 14.08C0.170017 14.2599 0.323909 14.3965 0.509382 14.4604C0.694999 14.5243 0.897393 14.5105 1.07312 14.4219L13.5996 8.16324C13.7605 8.08236 13.886 7.94182 13.9512 7.76982C14.0163 7.59781 14.0163 7.40676 13.9512 7.23476C13.886 7.06276 13.7605 6.92222 13.5996 6.84133L1.08171 0.578296C0.906003 0.489539 0.703456 0.475688 0.517854 0.539582C0.33239 0.603631 0.178649 0.740233 0.0897238 0.919949C0.000958493 1.09982 -0.0158191 1.3085 0.0430532 1.50097L1.54735 6.46435L7.25224 7.03513C7.4827 7.05874 7.65839 7.25876 7.65839 7.49763C7.65839 7.73668 7.48269 7.93668 7.25224 7.96013L7.25431 7.96486Z"
      className={`${className} sidenav-SVG`}
    />
  </svg>
);

const IconDisabledSVG = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.26995 6.19738H11.5557L7.55566 10.315L3.55566 6.19738H5.84138V2.66797H9.26995V6.19738ZM3.55566 12.6674V11.4909H11.5557V12.6674H3.55566Z"
      fill="#999999"
    />
  </svg>
);

export {
  UploadFileIconSVG,
  DownloadAllFileIconSVG,
  IconSVG,
  SendDocumentIconSVG,
  IconDisabledSVG,
};
